import * as React from "react";
const SvgFiRrCloudQuestion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M14.882 11.585c.429 1.66-.376 3.381-1.913 4.092-.165.076-.469.468-.469.823v.5a1 1 0 1 1-2 0v-.5c0-1.224.839-2.272 1.629-2.638a1.51 1.51 0 0 0 .817-1.777 1.47 1.47 0 0 0-1.03-1.03c-.483-.125-.957-.035-1.333.258-.371.287-.583.72-.583 1.188a1 1 0 1 1-2 0 3.48 3.48 0 0 1 1.359-2.77 3.51 3.51 0 0 1 3.058-.612 3.48 3.48 0 0 1 2.465 2.467M11.5 19a1.5 1.5 0 1 0 .001 3.001 1.5 1.5 0 0 0-.001-3m12.499-4.565c.001-.02.001.016 0 0m-6.024-7.262a1.03 1.03 0 0 1-.742-.569c-1.552-3.27-5.144-5.099-8.735-4.438a7.94 7.94 0 0 0-6.383 6.501 8.1 8.1 0 0 0 .033 2.89c.06.31-.073.653-.346.901A5.4 5.4 0 0 0 0 16.5C0 19.532 2.468 22 5.501 22h1.5a1 1 0 1 0 0-2h-1.5c-1.93 0-3.5-1.57-3.5-3.5 0-.98.407-1.89 1.146-2.562.786-.715 1.155-1.773.963-2.763a6.1 6.1 0 0 1-.023-2.18c.403-2.423 2.365-4.422 4.771-4.863 2.75-.499 5.386.835 6.567 3.328a3.01 3.01 0 0 0 2.158 1.674A5.51 5.51 0 0 1 22 14.515c-.008 2.861-2.237 5.272-4.999 5.485H16a1 1 0 1 0 0 2l1.077-.003c3.847-.293 6.874-3.692 6.922-7.562-.043-3.525-2.565-6.572-6.024-7.262"
    />
  </svg>
);
export default SvgFiRrCloudQuestion;
